import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector, connect } from 'react-redux';
import { useParams } from 'react-router-dom';

import { createAction } from '../../../utils';
import {
  saveDataToSessionStorage,
  removeDataFromSessionStorage,
} from '../../../models/AdminModel';
import BaseForm from '../../../components/base/v2/BaseForm';
import Loading from '../../../components/base/Loading';
import {
  SavedStatus,
} from '../../../config/CustomEnums';
import CustomBreadcrumb from '../../../components/base/CustomBreadcrumb';
import CreateAdminStepOne from './CreateAdminStepOne';

function CreateAdmin({
  admin,
  formHasSubmitted,
  hasUpdatedDefaultValues,
  saved,
}) {
  const history = useHistory();
  const dispatch = useDispatch();
  const params = useParams();
  const { id } = params;

  useEffect(() => {
    if (
      saved === SavedStatus.savedWithSuccess &&
      history.location.pathname.includes('edit')
    ) {
      history.push('/administrators');
    }
  }, [saved, history]);

  useEffect(() => {
    if (id) {
      dispatch(createAction('admin/getOneAdmin')({ id }));
    } else {
      dispatch({ type: 'admin/loadDataFromCookieSession' });
    }
  }, [dispatch, id]);

  if (id && !admin?.id) {
    return <Loading customClass={'common-full-height'} />;
  }
  const stepSet = [<CreateAdminStepOne />];
  return (
    <BaseForm
      defaultValues={admin}
      formHasSubmitted={formHasSubmitted}
      hasUpdatedDefaultValues={hasUpdatedDefaultValues}
      tempSave={(save, getValues) => {
        if (save) {
          saveDataToSessionStorage(getValues());
        } else {
          removeDataFromSessionStorage();
        }
      }}
      showFinishPop={saved === SavedStatus.savedWithSuccess}
      nextStepConfig={{
        title: 'Successfully Created!',
        description: 'Administrators is successfully created.',
        steps: null,
        buttons: [
          {
            text: 'Back to administrators list',
            action: () =>
              history.push({
                pathname: '/administrators',
              }),
          },
        ],
      }}
      content={stepSet}
      breadcrumb={
        <CustomBreadcrumb
          name={id ? admin.username : 'Create Administrators'}
        />
      }
      currentStep={0}
      caution={{
        detail: '',
        title: `${id ? admin.username : 'Create Administrators'}`,
        model: 'admin',
      }}
    />
  );
}

const mapPropsToState = (state) => ({
  admin: state.admin.oneAdmin || {},
  saved: state.admin.saved,
  hasUpdatedDefaultValues: state.admin.hasUpdatedDefaultValues,
  formHasSubmitted: state.admin.formHasSubmitted,
});

export default connect(mapPropsToState)(CreateAdmin);
